unit PersonalDataListType;

interface

uses
  PersonalDataType;

type
  TPersonalDataListType = array of TPersonalDataType;

implementation

end.
